import React, { useEffect, useState } from "react";
import "./VerifyTradeRanking.css";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { simplifyTradingVolume } from "../../../../helpers/helper";
import { useSelector } from "react-redux";
import { toastify } from "../../../../helpers/toast/toastify";
import { setRefetchMultiCommunityList } from "../../../../redux/multicommunity/multicommunity";

const VerifyTradeRanking = ({ user }) => {
  const [myRanking, setMyRanking] = useState(null);
  const [totalCommunities, setTotalCommunities] = useState(0);
  const [performanceYTD, setPerformanceYTD] = useState("0.00");
  const [potentialTradingAccount, setPotentialTradingAccount] =
    useState("0.00");
  const selectedCommunity = useSelector(
    (state) => state?.multiCommunity?.currentCommunity
  );
  const api = useApi();

  const getRanking = async () => {
    try {
      const response = await api("post", `/community/updateCommunityRankings`, {
        communityId: selectedCommunity?._id,
      });

      if (response && response.status) {
        setTotalCommunities(response?.data?.totalCommunities);
        setMyRanking(response?.data?.communityRanking);
        setRefetchMultiCommunityList(true);
      } else {
        const responsePro = await api(
          "get",
          "multiCommunity/allCommunityCount"
        );
        if (responsePro && responsePro.status) {
          if (
            user.role === "leader" &&
            !user.tradeName &&
            !user?.leaderCommunity
          ) {
            setTotalCommunities(responsePro?.data?.count);
            setMyRanking(responsePro?.data?.count);
          }
        }
      }
    } catch (err) {
      console.log(
        err,
        "this is a error please check and confirm and let me  know"
      );
    }
  };

  const getUserStats = async () => {
    const response = await api("post", "multiCommunity/getSpecificUserStats", {
      userIds: [user?._id],
    });
    if (response?.status) {
      const stats = response?.data;

      let PerformanceYTD = simplifyTradingVolume(stats?.PerformanceYTD || 0);
      PerformanceYTD =
        typeof PerformanceYTD === "string"
          ? PerformanceYTD
          : PerformanceYTD.toFixed(2);
      setPerformanceYTD(PerformanceYTD);

      let potentialTradingAccount = simplifyTradingVolume(
        stats?.potentialTradingAccount || 0
      );
      potentialTradingAccount =
        typeof potentialTradingAccount === "string"
          ? potentialTradingAccount
          : potentialTradingAccount.toFixed(2);
      setPotentialTradingAccount(potentialTradingAccount);
    }
  };

  useEffect(() => {
    if (user.role === "leader") {
      getRanking();
    } else {
      getUserStats();
    }
  }, [user]);
  return (
    <>
      {/* For Community Leader */}
      {((user?.role === "leader" && user?.leaderCommunity) ||
        (user.role === "leader" &&
          !user.tradeName &&
          !user?.leaderCommunity)) && (
        <div className="VerifyTradeRankingBox">
          <p className="title leaderTitle">Your Ranking</p>
          <div className="circle">
            <p className="numbers">
              {`${(myRanking || selectedCommunity?.myRanking || totalCommunities)??0}/${
                totalCommunities ?? 0
              }`}
            </p>
          </div>
          {/* <p className="subText">Amongst all trading groups</p> */}
        </div>
      )}

      {/* For Community Member */}
      {user?.role === "member" && (
        <div className="VerifyTradeRankingBox">
          <p className="title">Projected Account</p>
          <p className="subTitle">Next Year</p>
          <div className="circle">
            <div className="">
              <p className="member_numbers">${potentialTradingAccount}</p>
              <p className="percent">{performanceYTD}%</p>
            </div>
          </div>
          <p className="subText">Amongst all trading groups</p>
        </div>
      )}
    </>
  );
};

export default VerifyTradeRanking;
